// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import Player from "@vimeo/player";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import convert_floatToTimeString from "../../../../../app/baseUtilities/convert/convert_floatToTimeString";

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_vimeo", inline: true, disabled: false };
const msgs = {
  start: ["init. vimeo"],
  end: ["init. vimeo", "init. success"],
  no_el: ["init. vimeo", "no valid DOM el. provided"],
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_vimeo() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const compEl = this.element;
  const { vimeoIframe, btn_play, btn_fullscreen } = this.ref;
  this.logger("init", msgs.start, "action", logArgs);

  // Guard...
  if (!this.validate_refEl(vimeoIframe)) return this.cancel_featInit(msgs.no_el);

  ////////////////////////////////// Custom vimeo player init. ///////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // - Create Vimeo Player instance...
  // - Ensure instance is unmuted...
  const vimeoPlayerInst = new Player(vimeoIframe);
  vimeoPlayerInst.ready().then(() => vimeoPlayerInst.setVolume(1));

  // Instance event hdl. //
  vimeoPlayerInst.on("timeupdate", (EVENTDATA) => {
    const { percent, seconds } = EVENTDATA;
    this.setState({ playbackTime: seconds, playbackProgress: percent * 100 });
  });
  vimeoPlayerInst.on("play", () => {
    // - Set mode to "playing"...
    // - If cover is not hidden, hide it...
    // - Set data-has-started attr. on comp. el...
    this.setState({ mode: "playing" });
    const { coverState = { is_hidden: false } } = this.state;
    if (!coverState.is_hidden) this.setState({ coverState: { is_hidden: true } });
    compEl.setAttribute("data-has-started", "true");
  });
  vimeoPlayerInst.on("pause", () => this.setState({ mode: "paused" }));
  vimeoPlayerInst.on("ended", () => {
    // - Set mode to "ended"...
    // - If cover is hidden, show it...
    this.setState({ mode: "ended" });
    const { coverState = { is_hidden: true } } = this.state;
    if (coverState.is_hidden) this.setState({ coverState: { is_hidden: false } });
  });

  //////////////////////////////////////// Controls init. ////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  if (btn_play)
    btn_play.addEventListener("click", async () => {
      const is_paused = await vimeoPlayerInst.getPaused();
      if (is_paused) {
        this.setState({ mode: "loading" });
        vimeoPlayerInst.play();
      } else vimeoPlayerInst.pause();
    });

  if (btn_fullscreen) {
    // Init. btn. click hdl...
    btn_fullscreen.addEventListener("click", () => {
      if (this.state.is_fullscreen) document.exitFullscreen();
      else compEl.requestFullscreen();
    });

    // Init. fullscreen-change hdl...
    document.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement) this.setState({ is_fullscreen: true });
      else this.setState({ is_fullscreen: false });
    });
  }

  ///////////////////////////////// Playback progress bar init. //////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { progressBarWrapper, progressBar, seekBar, seekTimeDisplay } = this.ref;
  if (progressBarWrapper && progressBar) {
    // Seek video when progress bar wrapper clicked...
    progressBarWrapper.addEventListener("click", async (EVENTDATA) => {
      const duration = await vimeoPlayerInst.getDuration();
      const rect = progressBarWrapper.getBoundingClientRect();
      const offsetX = EVENTDATA.clientX - rect.left;
      const newTime = (offsetX / rect.width) * duration;
      vimeoPlayerInst.setCurrentTime(newTime);
    });

    // - Show seek bar when mouse enters progress bar wrapper...
    // - Show seek time display when mouse enters progress bar wrapper...
    // - Hide seek bar when mouse leaves progress bar wrapper...
    // - Hide seek time display when mouse leaves progress bar wrapper...
    progressBarWrapper.addEventListener("mouseenter", () => {
      seekBar.setAttribute("data-is-hidden", "false");
      seekTimeDisplay.setAttribute("data-is-hidden", "false");
    });
    progressBarWrapper.addEventListener("mouseleave", () => {
      seekBar.setAttribute("data-is-hidden", "true");
      seekTimeDisplay.setAttribute("data-is-hidden", "true");
    });

    // When mouse moves over progress bar wrapper:
    // - Updt. seek bar width prop. (--w)...
    // - Updt. seek time display with time relative to mouse position...
    progressBarWrapper.addEventListener("mousemove", async (EVENTDATA) => {
      const rect = progressBarWrapper.getBoundingClientRect();
      const offsetX = EVENTDATA.clientX - rect.left;
      seekBar.style.setProperty("--w", `${(offsetX / rect.width) * 100}%`);

      const duration = await vimeoPlayerInst.getDuration();
      const newTime = (offsetX / rect.width) * duration;
      seekTimeDisplay.textContent = convert_floatToTimeString(newTime);
    });
  }

  /////////////////////////////////// Auto-hiding of controls ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Hide controls when no mouse events for 3s while playing...
  let timeout;
  compEl.addEventListener("mousemove", () => {
    clearTimeout(timeout);
    this.setState({ controlsState: { ...this.state.controlsState, is_hidden: false } });
    timeout = setTimeout(() => {
      if (this.state.mode === "playing") this.setState({ controlsState: { ...this.state.controlsState, is_hidden: true } });
    }, 3000);
  });

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  this.modules.vimeo.instance = vimeoPlayerInst;
  this.logger("init", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
